export const getSelectOption = (category: string) => {
  return {
    label: category,
    value: category,
  };
};
